import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
    return twMerge(clsx(inputs));
}

export function formatPrice(price) {
    if (!price && price !== 0) return 'Consultar';
    return new Intl.NumberFormat('es-ES', {
        style: 'currency',
        currency: 'EUR',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
    }).format(price);
}

export function formatKm(km) {
    if (!km && km !== 0) return '-';
    return new Intl.NumberFormat('es-ES').format(km) + ' km';
}

export function buildWhatsAppUrl(settings, vehicle, pageUrl) {
    const number = settings?.whatsapp_number || '34600000000';
    let template = settings?.whatsapp_template || 'Hola ASG Motor, me interesa el {brand} {model}, Año {year}, {km} km, {price}€. Enlace: {url}';
    
    if (vehicle) {
        template = template
            .replace('{brand}', vehicle.brand || '')
            .replace('{model}', vehicle.model || '')
            .replace('{year}', vehicle.year || '')
            .replace('{km}', vehicle.km ? new Intl.NumberFormat('es-ES').format(vehicle.km) : '')
            .replace('{price}', vehicle.price ? new Intl.NumberFormat('es-ES').format(vehicle.price) : 'Consultar')
            .replace('{url}', pageUrl || window.location.href);
    } else {
        template = 'Hola ASG Motor, estoy interesado en vuestros vehículos.';
    }
    
    return `https://wa.me/${number}?text=${encodeURIComponent(template)}`;
}

export function getStatusBadge(status) {
    const map = {
        available: { label: 'Disponible', variant: 'default' },
        reserved: { label: 'Reservado', variant: 'secondary' },
        sold: { label: 'Vendido', variant: 'destructive' },
        hidden: { label: 'Oculto', variant: 'outline' },
    };
    return map[status] || { label: status, variant: 'outline' };
}

export function getEcoLabelColor(label) {
    const map = {
        '0': 'bg-blue-100 text-blue-800 border-blue-200',
        'ECO': 'bg-teal-100 text-teal-800 border-teal-200',
        'C': 'bg-emerald-100 text-emerald-800 border-emerald-200',
        'B': 'bg-yellow-100 text-yellow-800 border-yellow-200',
    };
    return map[label] || 'bg-gray-100 text-gray-800 border-gray-200';
}

export function slugify(text) {
    return text
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/(^-|-$)/g, '');
}
